module.exports = __webpack_public_path__ + "img/rhombus.138018f4.svg";